<script lang="ts">
  import LL from '$i18n/i18n-svelte';
  import { traitIdToResourceId } from './consts';
  import { getTraitCategoryString, getTraitName } from './translations';

  export let traitId: number;
  export let asCategory = false;

  $: resourceId = asCategory
    ? traitIdToResourceId[traitId]
    : `${getTraitCategoryString(traitId)}02`;
  $: src = `/images/traits/${resourceId}.webp`;
</script>

<img class="trait-image" {src} alt={getTraitName($LL, traitId)} {...$$restProps} />
